import type { BlocksInstallStepComponent } from '@twisto/api-cms'

import { Headline, Text } from '../../article-components'
import { Icon } from '../../atoms'

import * as styles from './install-step.styles'

export const InstallStep = ({
  headline,
  icon,
  text,
}: BlocksInstallStepComponent) => (
  <article className="install-step-item" css={styles.installStep}>
    {icon && (
      <div css={styles.icon}>
        <Icon color="primary" name={icon} size="48" />
      </div>
    )}
    <Headline name={headline} tag="h3" />
    <Text text={text} />
  </article>
)
